import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

const MainLayout = () => {
  return (
    <div className="flex flex-col min-h-screen relative selection:bg-slate-900 selection:text-white">
      {/* Sophistication Layer: Grain Texture */}
      <div className="grain-overlay" aria-hidden="true" />
      
      {/* Sophistication Layer: Ambient Auras */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10" aria-hidden="true">
        <div className="aura-blob w-96 h-96 bg-blue-100 top-[-10%] left-[-5%]" />
        <div className="aura-blob w-96 h-96 bg-slate-200 top-[40%] right-[-10%] animation-delay-2000" />
        <div className="aura-blob w-96 h-96 bg-indigo-50 bottom-[-10%] left-[20%] animation-delay-4000" />
      </div>

      <ScrollToTop />
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;